import React from 'react'
import { Link } from 'react-router-dom';

const AdvantagesSection = () => {
    const features = [
    {
      title: "Hands-on Learning",
      desc: "Practical projects in Scratch, Python, Roblox & more.",
    },
    {
      title: "Expert Guidance",
      desc: "Learn directly from certified instructors.",
    },
    {
      title: "Future-Ready Skills",
      desc: "Build coding, problem-solving & logical thinking.",
    },
    {
      title: "Creative Confidence",
      desc: "Boost imagination through fun & interactive challenges.",
    },
    {
      title: "Achievement Certificate",
      desc: "Get recognized for your skills with an official certificate.",
    },
  ];
  return (
    <section className=" bg-[#923D8C12] flex justify-center pt-16 pb-20">
      <div className="w-full mx-auto max-w-[1920px]">
        
        <div className="text-center flex flex-col w-full items-center">
          <h2 className="text-5xl font-medium mb-4 leading-[56px]">
            Exclusive Advantages Of Summer Coding Camp
          </h2>
          <p className='max-w-[988px] leading-[19px]'>
            Our students love the hands-on experience and personalized guidance 
            they receive in our courses. Here’s what some of them have to say 
            about their learning journey with us
          </p>
        </div>

        <div className="grid grid-cols-5 gap-8 mt-20 max-w-[1728px] mx-auto">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-white flex flex-col shadow-[0_8px_0px_0px_rgba(146,61,140,0.6)] items-center px-3  justify-around min-h-[307px]  "
            >
              <h3 className="text-[32px] text-center font-medium  leading-8">
                {item.title}
              </h3>
              <p className=" text-2xl font-medium text-center max-w-[233px] leading-[29px]">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="flex justify-center mt-28">
                <Link
                  to={"/camps/camps-registration"}
                  className="bg-[#FF6636] hover:bg-transparent font-bold text-white hover:text-[#FF6636] hover:border hover:border-[#FF6636] rounded-lg leading-[19px] py-[16.5px] max-w-[580px] w-full flex items-center justify-center"
                >
                  Claim your Spot
                </Link>
        </div>
      </div>
    </section>
  )
}

export default AdvantagesSection
